













































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ClosureService } from "@/services/ClosureService";
import { ClosuresDetailsDTO } from "@/model/data.model";
import * as moment from "moment";
import dateTime from "@/filters/DateTimeFilter";
import {
  GetClosureResults,
  ClosureListItem,
  SearchParams,
  IPagination
} from "@/model/component.model";
import Pagination from "@/components/shared/Pagination.vue";
import { popupFileBase64 } from "@/services/Helpers";

@Component({
  components: {
    Pagination: Pagination
  }
})
export default class ClosuresSearch extends Vue {
  @Prop() showSelectors: boolean;

  closures: ClosureListItem[] = [];
  allClosuresSelected = false;

  searchParams: SearchParams = {
    search: "",
    orderField: "manifestNumber", //'onlineMBEClosureId',
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200]
  };

  created() {
    this.closures = [];
    this.search();
  }

  @Watch("searchParams.search")
  search() {
    // Ensure that selectAll radio checkbox is deselected
    this.selectAll(false);

    this.closures = [];
    ClosureService.getClosures(
      this.$store.getters["customer/info"].customerId,
      this.searchParams
    )
      .then((res: GetClosureResults) => {
        this.closures = [];
        res.closures.forEach((item: ClosuresDetailsDTO) => {
          const o: ClosureListItem = { ...(item as ClosureListItem) };
          o.selected = false;
          this.closures.push(o);
        });
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.orderDirection = res.searchParams.orderDirection;
        this.searchParams.orderField = res.searchParams.orderField;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  @Watch("searchParams.sort") changeSortField() {
    this.search();
  }

  @Watch("searchParams.direction") changeSortDirection() {
    this.search();
  }

  sortTable(field: string, direction: string) {
    this.searchParams.orderField = field;
    this.searchParams.orderDirection = direction;
  }

  // Selection
  selectItem(item: ClosureListItem) {
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allClosuresSelected = value;
    this.closures.forEach((closure: ClosureListItem) => {
      closure.selected = value;
    });
  }

  convertDateToLocal(date: string) {
    const utcDate = moment.utc(date);
    return dateTime(String(utcDate.local()));
  }

  closuresSelected() {
    return this.closures.filter((closure: ClosureListItem) => closure.selected);
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }

  printManifestByAction(action?: string) {
    const closures = this.closuresSelected();
    if (closures.length === 0) return;
    ClosureService.printManifests(closures, 0, "MBE", action)
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(
            this.$t("notification_no_manifests").toString()
          );
        } else {
          res.forEach((base64document: string) => {
            const fileName = action
              ? this.$t("print_mbe_detailed_manifest")
              : this.$t("print_mbe_manifest");
            popupFileBase64(base64document, "PDF", `${fileName}.pdf`, this);
          });
        }
      })
      .catch(err =>
        this.$snotify.error(
          this.$t("notification_error_getting_manifests").toString()
        )
      );
  }
}
